import { Link, Text } from '@nimbus-ds/components';
import { useTranslationCommon } from 'commons/hooks';
import { useGoToConceptDetails } from 'domains/Billing/Checkout/hooks/useGoToConceptDetails';
import { AdBar } from './AdBar';

export function PaymentFailedAdBar() {
  const t = useTranslationCommon('topAdBar.paymentFailed');
  const goToDetails = useGoToConceptDetails('failedPaymentAdBar', 'plan-cost');
  return (
    <AdBar appearence="danger">
      <Text fontWeight="bold" color="danger-textLow">
        {t('text')}
      </Text>
      <Link appearance="primary" textDecoration="none" onClick={goToDetails}>
        {t('details')}
      </Link>
    </AdBar>
  );
}
